const envConfigs = "live";
// const envConfigs = "local_dev";
// const envConfigs = "local_live";
// const envConfigs = "dev";

export default envConfigs;
